<div class="navbar-wrapper">
  <igx-navbar *ngIf="!isPublic">
    <div igxNavbarTitle>
      <!-- <span igxButton="icon" igxToggleAction="navigation">
        <igx-icon family="material">menu</igx-icon>
      </span> -->
      <img src="/assets/logo.png" alt="" width="50px" height="50px">
      <span style="margin-left: 1rem;">
        Атмосфера Спорт
        @if (name) { <b>{{name}}</b> }
      </span>
    </div>
    <button *ngIf="userService.$isLoggedIn | async" igxButton="flat" type="button" [igxToggleAction]="options">
      <igx-avatar *ngIf="userService.$avatarUrl" [src]="(this.userService.$avatarUrl | async)!"></igx-avatar>
      <igx-avatar *ngIf="(userService.$avatarUrl | async) == null" [initials]="this.userService.initials ?? ''"></igx-avatar>
    </button>
  </igx-navbar>
</div>
<div class="content-wrap">
  <main class="main">
    <igx-tabs *ngIf="this.userService.$isLoggedIn | async">
      <igx-tab-item routerLinkActive #rlaTransport="routerLinkActive" [selected]="rlaTransport.isActive">
        <igx-tab-header routerLink="transport">
          <span igxTabHeaderLabel>Транспорт</span>
        </igx-tab-header>
      </igx-tab-item>
      <igx-tab-item routerLinkActive #rlaGroup="routerLinkActive" [selected]="rlaGroup.isActive">
        <igx-tab-header routerLink="group">
          <span igxTabHeaderLabel>Групи</span>
        </igx-tab-header>
      </igx-tab-item>
      <igx-tab-item routerLinkActive #rlaStaff="routerLinkActive" [selected]="rlaStaff.isActive" *ngIf="this.userService.$isAdmin | async">
        <igx-tab-header routerLink="edit-profiles">
          <span igxTabHeaderLabel>Служители</span>
        </igx-tab-header>
      </igx-tab-item>
      <igx-tab-item routerLinkActive #rlaKids="routerLinkActive" [selected]="rlaKids.isActive" *ngIf="this.userService.$isAdmin | async">
        <igx-tab-header routerLink="edit-kids">
          <span igxTabHeaderLabel>Деца</span>
        </igx-tab-header>
      </igx-tab-item>
      <igx-tab-item routerLinkActive #rlaParents="routerLinkActive" [selected]="rlaParents.isActive" *ngIf="this.userService.$isAdmin | async">
        <igx-tab-header routerLink="edit-parents">
          <span igxTabHeaderLabel>Родители</span>
        </igx-tab-header>
      </igx-tab-item>
      <igx-tab-item routerLinkActive #rlaParents="routerLinkActive" [selected]="rlaParents.isActive" *ngIf="this.userService.$isAdmin | async">
        <igx-tab-header routerLink="edit-programs">
          <span igxTabHeaderLabel>Програми</span>
        </igx-tab-header>
      </igx-tab-item>
      <igx-tab-item routerLinkActive #rlaParents="routerLinkActive" [selected]="rlaParents.isActive" *ngIf="this.userService.$isAdmin | async">
        <igx-tab-header routerLink="edit-enrollments">
          <span igxTabHeaderLabel>Заявки</span>
        </igx-tab-header>
      </igx-tab-item>
      <igx-tab-item routerLinkActive #rlaOptions="routerLinkActive" [selected]="rlaOptions.isActive" *ngIf="this.userService.$isAdmin | async">
        <igx-tab-header routerLink="add-payment">
          <span igxTabHeaderLabel>Плащания</span>
        </igx-tab-header>
      </igx-tab-item>
      <igx-tab-item routerLinkActive #rlaOptions="routerLinkActive" [selected]="rlaOptions.isActive" *ngIf="this.userService.$isAdmin | async">
        <igx-tab-header routerLink="settings">
          <span igxTabHeaderLabel>Настройки</span>
        </igx-tab-header>
      </igx-tab-item>
    </igx-tabs>
    <div class="content">
      <router-outlet></router-outlet>
    </div>
  </main>
</div>

<igx-drop-down #options (selectionChanging)="menuSelect($event)">
  <igx-drop-down-item [index]="0" igxRipple>Профил</igx-drop-down-item>
  <igx-drop-down-item [index]="1" igxRipple>Изход</igx-drop-down-item>
</igx-drop-down>

<div class="overlay">
    <div class="messages-container">
        <app-message class="msg" (despawned)="despawnMsg(msg.id)" [isDespawning]="true" [message]="msg" *ngFor="let msg of removedMessages"></app-message>
        <app-message class="msg" [message]="msg" *ngFor="let msg of messages"></app-message>
    </div>
</div>
<app-wait-indicator #waitIndicator></app-wait-indicator>
